<template>
    <span>
      <!-- check booking check -->
      <i
        :class="booking.checked ? 'fa fa-check-circle text-success' : 'fa fa-times-circle text-danger'"
        :title="booking.checked ? 'Reserva chequeada' : 'Reserva sin chequear'"
      ></i>
        <!-- check pickup service -->
      <!-- <i
        :class="booking.pickup_service ? 'fa fa-check-circle text-success' : 'fa fa-exclamation-triangle text-warning'"
        :title="booking.pickup_service ? 'Según la configuración, esta actividad tiene servicio de bus de recogida' : 'Sin servicio de bus de recogida'"
      ></i> -->

      <!-- check excursion service -->
      <!-- <i
        :class="booking.excursion_service ? 'fa fa-check-circle text-success' : 'fa fa-exclamation-triangle text-warning'"
        :title="booking.excursion_service ? 'Según la configuración, esta actividad tiene servicio de bus de excursión' : 'Sin servicio de bus de excursión'"
      ></i> -->

      <!-- check includes transport service -->
      <!-- <span v-if="booking.integration == 'zerotours'">
        <i
          :class="booking.includes_transport ? 'fa fa-check-circle text-success' : 'fa fa-exclamation-triangle text-warning'"
          :title="booking.includes_transport ? 'Excursión incluye transporte (según zerotours)' : 'No include transporte'"
        ></i>
      </span>
      <span v-else>
        <i class="fa fa-question-circle text-info" title="No se puede asegurar que tenga transporte incluido (no viene de zeroturs)">
        </i>
      </span> -->
    </span>
</template>

<script>
export default {
    props: {
        booking: {
            type: Object,
            required: true
        }
    }
}
</script>

<style scoped>
i {
  font-size: 14px;
  margin-left: 2px;
}
</style>